<div class="w-100">

  <div class="header" *ngIf="dialogData?.isOpenedFromDashboard">
<div class="d-flex w-100 py-3 px-4">
            <div class="me-2 id flex-fill">
              <h4 class="modal-title mb-0 item-id">
                {{ dialogData?.filteredStatus }}
              </h4>
            </div>

            <div class="btns-header">
              <button class="close" (click)="dialogRef.close()" aria-label="Close">
                <i class="fas fa-times" title="Close Popup"></i>
              </button>
              <!-- <button class="close expand-modal" (click)="expandCollapse()">
                <i class="fas ms-2 me-2" style="font-weight: bold;" [ngClass]="{'fa-expand-alt': !isExpanded, 'fa-compress-alt': isExpanded}"
                [title]="isExpanded ? 'Exit Full Screen' : 'Enter Full Screen'"></i>
              </button> -->
            </div>
          </div>
  </div>
@if (showGrid) {
  <ejs-grid
      #ooGrid
      [id]="gridName"
      [dataSource]="ooData"
      [height]="gridHeight"
      [allowPaging]="true"
      [pageSettings]="pageSettings"
      [gridLines]="false"
      [allowFiltering]="true"
      [allowSorting]="true"
      [enableHover]="false"
      [enablePersistence]="true"
      [allowResizing]="true"
      [allowReordering]="true"
      [showColumnChooser]="true"
      [allowExcelExport]="true"
      [allowSelection]="true"
      [editSettings]="{ allowEditing: false }"
      [filterSettings]="{ type: 'Menu' }"
      [selectionSettings]="{ mode: 'Both', checkboxOnly: true }"
      [searchSettings]='searchSettings'
      [query]="deleteQuery"
      (rowDataBound)="onRowDataBound($event)"
      (commandClick)="onCommandClick($event, ooGrid)"
      (actionBegin)="onGridActionBegin($event)"
      (actionComplete)="onGridActionComplete($event, ooGrid)"
      (toolbarClick)="onToolbarClick($event)"
      (created)="onGridCreated($event)"
      (excelQueryCellInfo)="onExcelQueryCellInfo($event)"
      >
      <e-columns>
          <e-column
              *ngFor="let column of columns;"
              [isPrimaryKey]="column.isPrimaryKey || false"
              [field]="column.field"
              [headerText]="column.headerText"
              [clipMode]="column.field === 'Actions' ? '' : 'EllipsisWithTooltip'"
              [type]="column.type"
              [width]="column.width"
              [filter]="column.filter ? column.filter : { type: 'Menu' }"
              [format]="column.format ? column.format : null"
              [textAlign]="column.textAlign"
              [showInColumnChooser]="column.showInColumnChooser ?? true"
              [visible]="column.visible"
              [commands]="column?.commands ? column.commands : null"
              [edit]="column.edit"
              [allowReordering]="column.allowReordering ?? true"
              [freeze]="column.freeze ? column.freeze: null"
              [allowEditing]="column.allowEditing"
              [allowSorting]="column.allowSorting ?? true"
              [allowFiltering]="column.allowFiltering !== undefined ? column.allowFiltering : true">

              @if (column?.field === 'vrfId') {
                <ng-template  #template let-data>
                    <a href="javascript:" (click)="onItemClick(data)">{{data[column?.field]}}</a>
                </ng-template>
              }
              @if (column?.field === 'status') {
              <ng-template #template let-data>
                <span class="grid-status-column" [ngStyle]="{'background-color': $safeNavigationMigration(data?.statusColor)}">
                  {{data.status}}
                </span>
              </ng-template>
            }
              @if (column?.field === 'startDate') {
              <ng-template #template let-data>
                {{convertDateFormat(data.startDate)}}
              </ng-template>
            }
              @if (column?.field === 'endDate') {
              <ng-template #template let-data>
                {{convertDateFormat(data.endDate)}}
              </ng-template>
            }

          </e-column>
      </e-columns>
  </ejs-grid>
}
</div>

<ng-template #columnChooser>
  <lib-column-chooser
     [grid]="ooGrid"
  ></lib-column-chooser>
</ng-template>

